// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"style__pageWrapper__Hc55V","header":"style__header__ctz35","footerImg":"style__footerImg__nqo2D","headerImg":"style__headerImg__nKsj0"};